import { axios } from '@/utils/request'

const api = {
  enterprisePrice: '/enterprise/price',
  orderType: '/basicdata/orderType',
}

export function getOrderTypeList (parameter) {
  return axios({
    url: api.orderType + `/getList/${parameter}`,
    method: 'get',
  })
}

export function getEnterprisePriceList (parameter) {
  return axios({
    url: api.enterprisePrice + '/list',
    method: 'get',
    params: parameter
  })
}

export function getEnterpriseAccessoryPrice (parameter) {
  return axios({
    url: api.enterprisePrice + '/accessory/list/' + parameter,
    method: 'get'
  })
}

export function saveAccessoryPrice (parameter) {
  return axios({
    url: api.enterprisePrice + '/accessory/update',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function updateEnterprisePrice (parameter) {
  return axios({
    url: api.enterprisePrice + '/update',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getOrderType (parameter) {
  return axios({
    url: '/basicdata/orderType/orderTypes',
    method: 'get',
    params: parameter
  })
}

export function delEnterprisePrice (parameter) {
  return axios({
    url: api.enterprisePrice + '/remove',
    method: 'post',
    params: parameter
  })
}

export const enterprisePriceExport = api.enterprisePrice + '/export'
